import { IWPImage, IWPLink } from "@/src/types";
import React from "react";

import S from "./CourseList.styled";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { MainInner } from "@/styles/global";
import { Link } from "gatsby";

import { ImageDataLike } from "gatsby-plugin-image";
import { usePostsData } from "./usePostData";

import { useLocalization } from "../../../contexts/Localization";

export interface Props {
  ctaText: string;
  noCourseAvailableText: string;
}

type Course = {
  title: string;
  url: string;
  slug: string;
  uri: string;
  published_at: string;
  excerpt: string;
  description: string;
  image_url: string;
  featuredImage: {
    node: {
      altText: string;
      sourceUrl: string;
      title: string;
      gatsbyImage: ImageDataLike;
    };
  };
  contentType: {
    node: {
      graphqlSingleName: string;
    };
  };
};

const CourseList: React.FC<Props> = ({ ctaText, noCourseAvailableText }) => {
  const { language } = useLocalization();
  const courses = usePostsData(language);

  return (
    <section className="relative w-full bg-gray-100">
      <div className="md:mx-auto md:max-w-7xl pt-16 pb-24">
        <div className="flex flex-col sm:center flex-wrap bg-white b-shadow rounded-md overflow-hidden">
          {courses.length > 0 ? (
            <>
              {courses.map((course: Course, idx: number) => {
                var courseImageData = course.featuredImage?.node?.gatsbyImage
                  ? getImage(course.featuredImage.node.gatsbyImage)
                  : null;

                return (
                  <S.InfoCard
                    key={idx}
                    className={"block md:flex p-6 border-b border-gray-200"}
                  >
                    <div
                      className="flex-1 relative overflow-hidden h-96 w-full rounded-md"
                      style={{
                        backgroundPosition: "center",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                      }}
                    >
                      {courseImageData && (
                        <S.CourseImage
                          image={courseImageData}
                          alt={"Sektionsbild"}
                          objectFit={"cover"}
                          className={
                            "object-center object-cover pointer-events-none"
                          }
                        />
                      )}
                    </div>
                    <div className="flex-1 py-9 px-9">
                      <h4 className="mt-0 text-2xl font-bold mb-2">
                        {course.title}
                      </h4>
                      <div
                        dangerouslySetInnerHTML={{ __html: course.excerpt }}
                      ></div>

                      {ctaText && (
                        <div className="mt-9 md:mt-0 flex sm:flex-row flex-col items-center">
                          <Link to={course.uri}>
                            <a className="sm:mt-6 mr-2 flex items-center justify-center border border-transparent text-base font-medium rounded-full text-white bg-metlab-500 transition duration-200 ease-in-out hover:bg-green-600 py-4 px-6 md:">
                              {ctaText && ctaText}
                            </a>
                          </Link>
                        </div>
                      )}
                    </div>
                  </S.InfoCard>
                );
              })}
            </>
          ) : (
            <>
              <div className="no-courses">
                {noCourseAvailableText ?? noCourseAvailableText}
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default CourseList;
